import React from 'react';
import { Box, Heading, Icon } from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
    title: string;
    onBack?: () => void;
    backPath?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, onBack, backPath }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else if (backPath) {
            navigate(backPath);
        } else {
            // По умолчанию возвращаемся назад в истории
            navigate(-1);
        }
    };

    return (
        <Box>
            <Box h="76px"></Box>
            <Box
                position="fixed"
                top={0}
                left={{ base: 0, lg: '280px' }}
                right={0}
                zIndex={10}
                bg="gray.100"
                py={4}
                px={{ base: 4, lg: 6 }}
            >
                <Box position="relative" w={{ base: 'full', lg: '600px' }} mx="auto">
                    {/* Кнопка назад с position absolute */}
                    <Box
                        position="absolute"
                        left={0}
                        top="50%"
                        transform="translateY(-50%)"
                        zIndex={1}
                        cursor="pointer"
                    >
                        <Icon as={FiArrowLeft} size="lg" color="black" onClick={handleBack} />
                    </Box>

                    {/* Заголовок по центру */}
                    <Box textAlign="center" w="full">
                        <Heading
                            size="lg"
                            color="gray.800"
                            my={2}
                            style={{ fontFamily: "'Oswald', sans-serif" }}
                        >
                            {title}
                        </Heading>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default PageHeader;
